import React from "react";
import { Input } from "@fluentui/react-components";
import styles from "./textField.module.scss";

export interface TextFieldProps {
    isInvalid?: boolean;
    errorMessage?: string;
    text: string;
    iconComponent?: React.ReactNode;
    showSuccessIndicator?: boolean;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    className?: string;
    autoComplete?: string;
    fluid?: boolean;
    handleDataChange: (value: string) => void;
}

const TextField: React.FC<TextFieldProps> = (props: TextFieldProps) => {
    const {
        iconComponent,
        isInvalid,
        errorMessage,
        handleDataChange,
        showSuccessIndicator,
        fluid,
        text,
        ...passThroughProps
    } = props;

    const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        handleDataChange(e.target.value);
    };

    return (
        <div className={styles.textFieldWrapper}>
            <div className={styles.iconComponent}>{iconComponent ?? null}</div>
            <Input
                {...passThroughProps}
                value={text}
                aria-invalid={isInvalid}
                onChange={handleOnChange}
                style={{ width: "100%" }}
            />
            <p className={styles.errorMessage}>{isInvalid && errorMessage}</p>
        </div>
    );
};

export default TextField;
